import { ACTION_TYPES } from './types';

export const updateLoanDetails = (loanDetails: any): any => ({
  type: ACTION_TYPES.UPDATE_LOAN_DETAILS,
  payload: [loanDetails, null],
});

export const updateLifeAssurance = (lifeAssurance: any): any => ({
  type: ACTION_TYPES.UPDATE_LIFE_ASSURANCE,
  payload: [lifeAssurance, null],
});

export const updateProperty = (property: any): any => ({
  type: ACTION_TYPES.UPDATE_PROPERTY,
  payload: [property, null],
});

export const updateAdmin = (admin: any): any => ({
  type: ACTION_TYPES.UPDATE_ADMIN,
  payload: [admin, null],
});

export const updateRepaymentStrategy = (repaymentStrategy: any): any => ({
  type: ACTION_TYPES.UPDATE_REPAYMENT_STRATEGY,
  payload: [repaymentStrategy, null],
});

export const updateApplicant = (applicant: any, index: any): any => ({
  type: ACTION_TYPES.UPDATE_APPLICANT,
  payload: [{ applicant, index }, null],
});

export const updateRationale = (rationale: any): any => ({
  type: ACTION_TYPES.UPDATE_RATIONALE,
  payload: [rationale, null],
});
